import { Controller, useFormContext } from 'react-hook-form'

import { CheckBox, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const NoAmountInvolved = () => {
  const { control, setValue, clearErrors } = useFormContext<SarEdit>()
  return (
    <Controller
      name="suspiciousActivityInfo.noAmountInvolved"
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          input={(props) => (
            <CheckBox
              {...props}
              checkBoxLabel="No amount involved"
              onChange={(value) => {
                if (value) {
                  setValue('suspiciousActivityInfo.amountUnknown', false)
                  clearErrors('suspiciousActivityInfo.currentAmount')
                }
                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
